import React, { createElement } from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
// Meta Pixel Integration
const metaPixelCode = `
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '1523922919315648');
  fbq('track', 'PageView');
`;
const script = document.createElement('script');
script.innerHTML = metaPixelCode;
document.head.appendChild(script);
const noscript = document.createElement('noscript');
noscript.innerHTML = `&lt;img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1523922919315648&amp;ev=PageView&amp;noscript=1" /&gt;`;
document.body.appendChild(noscript);
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode data-id="element-2" data-mp="1ak5eioo12gsu">
    <App data-id="element-3" data-mp="15nexnz4efh6d" />
  </React.StrictMode>);